<template>
  <div class="row px-3 pt-3">
    <div class="row px-3 m-auto col-12">
      <div class="col-12 col-md-6 justify-content-start">
        <h3 class="mt-0 pt-0 pl-0 mb-1 text-capitalize">
          {{ title }}
        </h3>
      </div>

      <div
          v-if="showMassAllocateButtons"
          class="col-12 col-md-6 d-flex flex-column flex-md-row justify-content-end"
      >
        <button class="btn btn-themed-o mb-1 mb-md-0 mr-md-1 p-1" @click="$emit('mass-allocate', true, 1)">
          {{ $t('flexben.benefit_groups.btn.add_all_ro') }}
        </button>

        <button class="btn btn-themed-o mb-1 mb-md-0 mr-md-1 p-1" @click="$emit('mass-allocate', true, -1)">
          {{ $t('flexben.benefit_groups.btn.add_all_int') }}
        </button>

        <button class="btn btn-themed-o mb-1 mb-md-0 mr-md-1 p-1" @click="$emit('mass-allocate', true)">
          {{ $t('flexben.benefit_groups.btn.add_all') }}
        </button>

        <button class="btn btn-themed-o mb-1 mb-md-0 mr-md-1 px-7 mx-8" @click="$emit('mass-allocate', false, -1)">
          {{ $t('flexben.benefit_groups.btn.remove_all_int') }}
        </button>

        <button class="btn btn-themed-o mb-1 mb-md-0 mr-md-1 px-7 mx-8" @click="$emit('mass-allocate', false)">
          {{ $t('flexben.benefit_groups.btn.remove_all') }}
        </button>
      </div>
    </div>

    <div class="col-12 mb-1">
      <div class="table-responsive scaled-table">
        <table class="table table-striped">
          <thead>
          <tr>
            <td class="w-25">{{ $t("flexben.benefit_groups.detail.ben_name") }}</td>

            <td v-if="showPartnerColumn" class="w-10">
              {{ $t("flexben.benefit_groups.detail.partner_name") }}
            </td>

            <td class="w-50 d-none d-md-table-cell">
              {{ $t("flexben.benefit_groups.detail.description") }}
            </td>

            <td class="w-25">
              {{ $t("flexben.benefit_groups.detail.allocation_control") }}
            </td>
          </tr>
          </thead>

          <tbody v-if="items.length > 0">
          <tr v-for="benefit in items" :key="benefit.id">
            <td class="w-25">
              <span
                  :style="{ backgroundColor: benefit.color }"
                  class="color-bullet"
              ></span>
              {{ benefit.name }}
            </td>

            <td v-if="showPartnerColumn" class="w-10">
              <div class="text-ellipsis-40">
                {{ benefit.partner ? benefit.partner.name : '-' }}
              </div>
            </td>

            <td class="w-50 d-none d-md-table-cell">
              <div
                  class="links-container"
                  :class="{ 'text-ellipsis-40': readMoreBenId !== benefit.id }"
                  v-html="getBenefitDescription(benefit)"
              ></div>

              <br>

              <a
                  class="text-themed btn-link cursor-pointer"
                  v-if="getBenefitDescription(benefit).length > 40"
                  @click="toggleReadMore(benefit.id)"
              >
                {{ $t('flexben.general.' + (benefit.id === readMoreBenId ? 'read_less' : 'read_more')) }}
              </a>
            </td>

            <td class="d-inline-flex w-25">
              <b-form-checkbox
                  :id="'benefit_toggle_' + benefit.id"
                  switch
                  :checked="formData.benefit_ids.includes(benefit.id)"
                  @change="$emit('toggle-benefit-id', benefit.id)"
              />

              <span class="ml-3 my-auto">
                {{ $t("flexben.benefit_groups.detail." + (formData.benefit_ids.includes(benefit.id) ? 'allocated' : 'not_allocated')) }}
              </span>
            </td>
          </tr>
          </tbody>

          <tbody v-else>
          <tr>
            <td
                :colspan="showPartnerColumn ? 4 : 3"
                class="text-center trhover gri-cell"
            >
              {{ $t("flexben.benefit_groups.no_benefits_available", {
              type: $t(emptyTypeKey)
              }) }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { BFormCheckbox } from "bootstrap-vue";

export default {
  name: "BenefitsTable",

  components: {
    "b-form-checkbox": BFormCheckbox,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: function () {
        return [];
      },
    },
    currentLang: {
      type: String,
      default: "ro",
    },
    formData: {
      type: Object,
      required: true,
    },
    emptyTypeKey: {
      type: String,
      default: "flexben.benefit_groups.benefit_type_flexible",
    },
    showMassAllocateButtons: {
      type: Boolean,
      default: false,
    },
    showPartnerColumn: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      readMoreBenId: null,
    };
  },

  watch: {
    items() {
      this.readMoreBenId = null;
    },
  },

  methods: {
    getBenefitDescription(benefit) {
      if (!benefit.description) {
        return "";
      }

      return benefit.description[this.currentLang] || "";
    },

    toggleReadMore(benefitId) {
      this.readMoreBenId = this.readMoreBenId === benefitId ? null : benefitId;
    },
  },
};
</script>